import { render, staticRenderFns } from "./InternalNotes.vue?vue&type=template&id=1dcbb92e&"
import script from "./InternalNotes.vue?vue&type=script&lang=js&"
export * from "./InternalNotes.vue?vue&type=script&lang=js&"
import style0 from "./InternalNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSheet,VTextarea})
